import Select, { components } from 'react-select';

import React from 'react';

const DropdownIndicator = (props) => {
  const { isFocused, selectProps } = props;
  const { menuIsOpen } = selectProps;

  return (
    <components.DropdownIndicator {...props}>
      <div
        style={{
          backgroundAttachment: 'scroll',
          backgroundColor: 'transparent',
          backgroundImage: `url('/resources/assets/ui/nextgen/expand_${
            isFocused && menuIsOpen ? 'less' : 'more'
          }.svg')`,
          backgroundPosition: '0 0',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '24px',
          overflow: 'hidden',
          width: '24px',
        }}
      />
    </components.DropdownIndicator>
  );
};

const NoIndicatorSeparator = () => null;

const SelectWrapper = ({ components, isInvalid, ...rest }) => {
  return (
    <Select
      {...rest}
      components={{
        ...components,
        DropdownIndicator,
        IndicatorSeparator: NoIndicatorSeparator,
      }}
      maxMenuHeight={208}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: '#ffffff',
          border: isInvalid
            ? '2px solid #b50024'
            : state.isFocused
            ? state.menuIsOpen
              ? '1px solid #00263e'
              : '2px solid #3aa1bc'
            : '1px solid #c9cdd0',
          borderRadius: state.isFocused && state.menuIsOpen ? '8px 8px 0 0' : '8px',
          boxShadow: 'none',
          height: '40px',
          outline: 0,
          padding: '0 8px',
          ':hover': {
            border: isInvalid
              ? '2px solid #b50024'
              : state.isFocused && state.menuIsOpen
              ? '1px solid #00263e'
              : '2px solid #3aa1bc',
          },
        }),
        dropdownIndicator: (baseStyles) => ({
          ...baseStyles,
          padding: '0',
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          borderRadius: '0 0 8px 8px',
          marginTop: '0',
        }),
        menuList: (baseStyles) => ({
          ...baseStyles,
          paddingTop: '0',
          paddingBottom: '8px',
        }),
        option: (baseStyles) => ({
          ...baseStyles,
          alignItems: 'center',
          display: 'flex',
          height: '40px',
          padding: '0 16px',
        }),
        valueContainer: (baseStyles) => ({
          ...baseStyles,
          padding: '0 8px 0 0',
        }),
      }}
    />
  );
};

export default SelectWrapper;
